import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditTransferGoods from '../components/addEditTransferGoods.vue';

var AddTransferGoodsPage = function (_super) {
  __extends(AddTransferGoodsPage, _super);

  function AddTransferGoodsPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddTransferGoodsPage = __decorate([Component({
    components: {
      AddEditTransferGoods: AddEditTransferGoods
    }
  })], AddTransferGoodsPage);
  return AddTransferGoodsPage;
}(Vue);

export default AddTransferGoodsPage;